import Box from "@mui/material/Box";
import type { InventoryStatus } from "@/api/inventory/_models/Inventory";
import { toChipBadgeColourSx, toChipColourSx } from "@/app/chip.utils";
import { INVENTORY_LIST_STATUS_HUE, INVENTORY_LIST_STATUS_LABEL } from "./inventoryList.utils";

interface InventoryListStatusChipProps {
  status: InventoryStatus | null;
  count?: number;
}

/**
 * An inventory row's reconciliation status as a tinted chip (like the order
 * status chip), with an optional count after the label.
 */
export const InventoryListStatusChip = (props: InventoryListStatusChipProps) => {
  const { status, count } = props;
  if (!status) return null;
  const hue = INVENTORY_LIST_STATUS_HUE[status];

  return (
    <Box
      sx={[
        toChipColourSx(hue),
        {
          alignItems: "center",
          borderRadius: 0.5,
          display: "inline-flex",
          fontSize: 12,
          fontWeight: 700,
          gap: 0.75,
          letterSpacing: "0.05em",
          lineHeight: "20px",
          maxWidth: "100%",
          px: 0.75,
          textTransform: "uppercase",
          verticalAlign: "middle",
          whiteSpace: "nowrap",
        },
      ]}
    >
      {INVENTORY_LIST_STATUS_LABEL[status]}
      {count !== undefined && (
        <Box
          component="span"
          sx={[
            toChipBadgeColourSx(hue),
            {
              alignItems: "center",
              borderRadius: 999,
              display: "inline-flex",
              fontSize: 11,
              height: 16,
              justifyContent: "center",
              letterSpacing: 0,
              minWidth: 16,
              px: 0.5,
            },
          ]}
        >
          {count.toLocaleString()}
        </Box>
      )}
    </Box>
  );
};
